class RouteConstants {
  static BookEditionPagePath = "bookEditionPage";
  static BookPagePAth = "AllEditionsPage";
}

export default RouteConstants;
